import { BaSeButton, BaSeDialogContext, BaSeTheme } from '@base/react';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { useInterviewController } from '../../../../../../../hooks/controllers/interview-controller';
import { useModule } from '../../../../../../../hooks/module/module';
import ConfirmGenerateCertificate from './confirm-generate-certificate';
import GenerateCertificateData from './generate-certificate-data';
import { Container, FooterContainer } from './generate-certificate-style';

const MAPPER_DAYS = {
  5: {
    value: 'FIVE_DAYS',
    desc: '5 dias',
  },
  6: {
    value: 'SIX_DAYS',
    desc: '6 dias',
  },
};
// eslint-disable-next-line sonarjs/cognitive-complexity
function GenerateCertificate({ values, closeModal, reloadData }) {
  const { moduleSelected } = useModule();
  const [confirmGenerate, setConfirmGenerate] = useState(false);

  const [initialDate, setInitialDate] = useState();
  const [finalDate, setFinalDate] = useState();
  const [cargaHoraria, setCargaHoraria] = React.useState(60);
  const [loadingButton, setLoadingButton] = React.useState(false);
  const [radioTypeSeminar, setRadioTypeSeminar] = React.useState(5);

  const { showNotification } = React.useContext(BaSeDialogContext);
  const { gerarCertificado } = useInterviewController();

  const formatDate = (date) => {
    return format(new Date(date), 'yyyy/MM/dd').replaceAll('/', '-');
  };
  const [data, setData] = React.useState(values);

  React.useEffect(() => {
    if (!moduleSelected?.id) return;
    if (moduleSelected?.id === 3) {
      setCargaHoraria(44);
    }
  }, [moduleSelected]);

  const sendDataToGenerateCertificate = React.useCallback(() => {
    setLoadingButton(true);
    const dataParsed = {
      beginDate: formatDate(new Date(initialDate), 'yyyy/MM/dd'),
      endDate: formatDate(new Date(finalDate), 'yyyy/MM/dd'),
      courseHours: cargaHoraria.toString(),
      generateCertificateClass: false,
      idsInterview: data.map((value) => value.id),
      seminarType: moduleSelected?.id !== 1 ? 'SIX_DAYS' : MAPPER_DAYS[radioTypeSeminar].value ?? 'FIVE_DAYS',
    };
    gerarCertificado(dataParsed)
      .then(() => {
        showNotification({
          message: 'Sucesso!',
          supportMessage:
            'Operação realizada com sucesso.',
          secondsToClose: 5,
          color: 'confirmation',
        });
      })
      .then(() => reloadData())
      .finally(() => {
        setLoadingButton(false);
        closeModal('');
      });
  }, [
    initialDate,
    moduleSelected,
    radioTypeSeminar,
    finalDate,
    cargaHoraria,
    data,
    gerarCertificado,
    closeModal,
    showNotification,
    reloadData,
  ]);

  return (
    <Container>
      {confirmGenerate ? (
        <ConfirmGenerateCertificate
          finalDate={finalDate}
          initialDate={initialDate}
          cargaHoraria={cargaHoraria}
          seminarType={MAPPER_DAYS[radioTypeSeminar].desc ?? '5 dias'}
        />
      ) : (
        <GenerateCertificateData
          data={data}
          finalDate={finalDate}
          setData={setData}
          setFinalDate={setFinalDate}
          setInitialDate={setInitialDate}
          initialDate={initialDate}
          cargaHoraria={cargaHoraria}
          setCargaHoraria={setCargaHoraria}
          radioTypeSeminar={radioTypeSeminar}
          setRadioTypeSeminar={setRadioTypeSeminar}
          moduleSelected={moduleSelected}
        />
      )}

      {confirmGenerate ? (
        <FooterContainer>
          <BaSeButton
            value="Confirmar"
            isLoading={loadingButton}
            onClick={() => {
              // setConfirmGenerate((prev) => !prev);
              sendDataToGenerateCertificate();
            }}
            color={BaSeTheme.colors.defaultColors.black}
          />
          <BaSeButton
            value="Revisar"
            type="secondary"
            color={BaSeTheme.colors.defaultColors.black}
            onClick={() => setConfirmGenerate((prev) => !prev)}
          />
        </FooterContainer>
      ) : (
        <FooterContainer>
          <BaSeButton
            value="Gerar certificado"
            onClick={() => {
              if (
                initialDate === undefined ||
                finalDate === undefined ||
                cargaHoraria === 0 ||
                cargaHoraria === undefined ||
                cargaHoraria === ''
              ) {
                showNotification({
                  message: 'Erro!',
                  supportMessage:
                    'É necessário preencher todas as informações sobre o seminário!',
                  secondsToClose: 5,
                  color: 'destructive',
                });
                return;
              }
              setConfirmGenerate((prev) => !prev);
            }}
            color={BaSeTheme.colors.defaultColors.black}
          />
          <BaSeButton
            value="Cancelar"
            type="secondary"
            color={BaSeTheme.colors.defaultColors.black}
            onClick={() => closeModal()}
          />
        </FooterContainer>
      )}
    </Container>
  );
}

export default GenerateCertificate;
